"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var title = (0, _glamor.css)({
  color: _css.colors.white,
  fontWeight: 300,

  margin: (0, _css.unitRem)(0.66) + " 0"
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1.5,
    medium: 1.4,
    large: [1.4, 1.875]
  }
}));

var ul = (0, _glamor.css)({
  listStyle: "disc",

  paddingLeft: 0,
  margin: (0, _css.unitRem)(0.66) + " 0",

  lineHeight: (0, _css.unitRem)(1.5)
});

var li = (0, _glamor.css)({
  color: _css.colors.gray,
  fontWeight: 300,

  marginLeft: (0, _css.unitRem)(1),
  paddingLeft: (0, _css.unitRem)(0.25)
}, (0, _polyfluid.polyfluid)({
  fontSize: {
    small: 1,
    medium: 0.85,
    large: [0.85, 1.125]
  }
}));

var Notes = function Notes(props) {
  return _react2.default.createElement(
    "ul",
    { className: ul },
    props.notes.map(function (note) {
      return _react2.default.createElement(
        "li",
        { className: li },
        note
      );
    })
  );
};

var ReleaseNotes = function ReleaseNotes(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h1",
      { className: title },
      props.title
    ),
    _react2.default.createElement(Notes, { notes: props.notes })
  );
};

exports.default = ReleaseNotes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Mixer/Components/ReleaseNotes.jsx
// module id = 2932
// module chunks = 0